import SUBSTITUTION_TYPES from '../utils/substituteLocales/substitutionTypes';
import { faqLinks } from '../constants/links';

export default {
  commonTexts: {
    button: {
      save: 'Сохранить',
      cancel: 'Отмена',
      back: 'Назад',
    },
    tableProductsHeader: {
      name: 'Название',
      vendorCode: 'Артикул',
      price: 'Цена',
      action: 'Действие',
    },
    multiselect: {
      submitButton: 'Добавить к акции',
      cancelButton: 'Отмена',
      selectAllButton: 'Выбрать все',
      selectNoneButton: 'Отменить выделение',
      products: {
        placeholder: 'Название товара или артикул',
        pageText: 'Страница',
        emptyList: {
          title: 'Нет такого товара',
          description: 'Попробуйте другое название или очистите поиск, чтобы посмотреть все товары',
        },
      },
      categories: {
        placeholder: 'Название категории или артикул',
        emptyList: {
          title: 'Нет такой категории',
          description:
            'Попробуйте другое название или очистите поиск, чтобы посмотреть все категории',
        },
      },
    },
  },
  indexPage: {
    bundlesAreaTitle: 'Комплекты магазина',
    bundlesAreaSubtitle:
      'Вы можете редактировать и удалять комплекты, а также временно отключать предложения и включать обратно',
    pageTitle: 'Комплекты',
    addLabelAreaTitle: 'Привлеките внимание к товарам',
    addLabelAreaSubtitle:
      'Объединяйте товары в наборы со скидкой, чтобы Покупатель отправлял в корзину сразу несколько позиций и тратил больше денег в вашем магазине',
    faqAreaTitle: 'FAQ',
    faqAreaSubtitle: {
      html: 'Особенности работы приложения, которые необходимо учитывать при его использовании. Если у вас возникнут вопросы или трудности - <a href="https://simcase-apps.omnidesk.ru/?send=question" target="_blank">свяжитесь с нами</a>, мы обязательно поможем',
    },
    faq: {
      question1: {
        title: 'Promo Item Header',
        content:
          'Advertise and sell your products directly through your page and reach billions of potential customers. Advertise and sell your products directly through your page and reach billions of potential customers.',
      },
      question2: {
        title: 'Promo Item Header',
        content:
          'Advertise and sell your products directly through your page and reach billions of potential customers. Advertise and sell your products directly through your page and reach billions of potential customers.',
      },
    },
    iconableBlockTitle: 'Собрать комплект',
    iconableBlockDescription:
      'Создавайте комплекты, объединенные общей идеей: наборы к праздникам или комплементарные товары. Подскажите Покупателю, что дополнит его корзину, и подкрепите предложение заманчивой скидкой',
    addNewBundle: 'Добавить комплект',
    card: {
      action: 'Действия',
      actionUpdate: 'Редактировать',
      actionDelete: 'Удалить',
    },
    removeBundleModal: {
      label: 'Вы действительно хотите удалить комплект?',
      agreeButton: 'Да',
      cancelButton: 'Нет',
    },
  },
  homePage: {
    title: 'Комплект',
    addToShopArea: {
      title: 'Новый комплект товаров',
      subtitle:
        'Определите, какие товары будут входить в комплект и какая скидка будет к ним применяться',
      interactiveBlock: {
        title: 'Собирайте товары в комплекты, чтобы увеличить продажи',
        subtitle:
          'Предложите покупателям скидку на комплект, чтобы мотивировать их покупать больше товаров',
        buttonText: 'Создать комплект',
      },
    },
    promotionsArea: {
      title: 'Управление комплектами',
      subtitle: 'Вы можете легко создавать или удалять комплекты, менять их состав и размер скидки',
      interactiveBlock: {
        actionButton: {
          title: 'Действия',
          actionsList: {
            edit: 'Редактировать',
            delete: 'Удалить',
          },
        },
      },
      dialogDelete: {
        title: 'Вы действительно хотите удалить акцию ?',
        submitButton: 'Да',
        cancelButton: 'Нет',
      },
    },
    shopRevisionArea: {
      title: 'Доработайте магазин под ваши нужды',
      subtitle:
        'Иногда просто скидки недостаточно: нужно подсказать покупателю, какой товар еще добавить в корзину.',
      interactiveBlock: {
        title: 'Товарные рекомендации',
        subtitle:
          'Помогите клиенту собрать все товары для 1+1=3 и предложите ему аксессуары, сопутствующие товары или аналоги подороже!',
        buttonText: 'Создать акцию',
      },
    },
    bannerAreaTheFirst: {
      title: 'Автоматизация бизнеса: новый шаг',
      subtitle:
        'Легко назначайте, меняйте и удаляйте товарные лейблы. Яркие надписи на карточке товара – отличный способ выделить новинки, товары со скидкой или бестселлеры. Забудьте о долгой и изнурительной ручной настройки каждого лейбла. С нашим приложением вы можете управлять лейблами автоматически, и настраивать их для целых категорий!',
        buttonText: 'Автоматизируйте лейблы',
    },
  },
  detailPromotionPage: {
    title: 'Настройка акции',
    setupPromotionArea: {
      title: 'Настройка акции',
      subtitle: 'Здесь вы можете управлять параметрами акции.',
      interactiveBlock: {
        section_1: {
          toggleHint: 'Включить акцию',
        },
        section_2: {
          title_1: 'Акция',
          parameter: {
            title: 'Параметр',
            option_1: 'Назначить скидку',
            option_2: 'Задать цену',
          },
          meaning: {
            title: 'Значение',
            hint_1: '(100 - бесплатно)',
          },
          title_2: 'Описание акции для покупателей',
          descriptionPlaceholder: 'Введите описание',
          descriptionError: 'Описание не должно быть пустым',
        },
      },
      errorMessage: 'Максимальное значение',
    },
    setupPurchaseArea: {
      title: 'Настройка покупок',
      subtitle: 'Здесь вы можете настроить условие получения акции.',
      interactiveBlock: {
        productsAmount: {
          title: 'Количество товаров',
          subtitle: 'Укажите количество товаров, при покупке которого будет доступная акция',
        },
        productsBinding: {
          title: 'Привязка товаров для покупки',
          subtitle: 'Выберите товары, после покупки которых будет доступна акция.',
        },
        productCategoriesBinding: {
          title: 'Привязка категорий товаров для покупки',
          subtitle: 'Выберите категории, товары из которых будут участвовать в акции.',
        },
        variants: {
          title: 'Варианты: ',
        },
        checkedCombinationAmount: {
          title: 'Участвуют в акции: ',
        },
        productNameUnAvailable: {
          title: 'Название отсутствует',
        },
      },
    },
    setupDiscountArea: {
      title: 'Настройка скидок',
      subtitle: 'Здесь вы можете указать товары или категории, на которые будет активна скидка.',
      interactiveBlock: {
        productsBinding: {
          title: 'Привязка товаров для получения скидки',
          subtitle: 'Выберите товары, на которые будет активна скидка.',
        },
        productCategoriesBinding: {
          title: 'Привязка категорий товаров для получения скидки',
          subtitle: 'Выберите категории, на товары из которых будет активна скидка.',
        },
        productsManualBinding: {
          title: 'Выбрать товара',
          subtitle: 'Выберите товары, на которые будет активна ссылка',
        },
        baseProductDefaultParameters: {
          title: 'Базовый товар',
          size: 'Размер: любое',
          color: 'Цвет: любое',
        },
      },
    },
    setupDisplayPromotionArea: {
      title: 'Настройка показа акции',
      interactiveBlock: {
        title: 'Выберите тип отображения акции',
        displayTypeSelectBox: {
          option_1: 'Автоматически',
          option_2: 'Используя купон',
        },
        couponInput: {
          title: 'Введите код купона для активации скидки',
          placeholder: 'Введите код купона',
        },
      },
    },
    FAQ_Area: {
      title: 'FAQ',
      subtitle:
        'Если у вас возникнут вопросы или трудности — свяжитесь с нами, мы обязательно поможем.',
      substitutions: [
        {
          type: SUBSTITUTION_TYPES.LINK,
          name: 'свяжитесь с нами',
          text: 'свяжитесь с нами',
          payload: {
            href: faqLinks.contactUs,
            target: '_blank',
          },
        },
      ],
    },
  },
};
